import React, { useState, useEffect } from "react";
import { Loader } from './Loader';

const LightboxImage = ({ path, issue, index}) =>  {

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
    }, [index]);

    return (
        <>  
            { loading ? <Loader/> : null } 
            <img className={'lightbox__image' + (!loading ? ' lightbox__image--loaded' : '' )} src={`//media.motorsportmagazine.com/${ path }/${ issue }/full/${ index }.jpg.webp`} onLoad={ () => setLoading(false)} />
        </>
    );

};

export default LightboxImage;

